/* Version Snapshot 0.2.0
   Eredeti verzió a tarki adatbank projektben.
   Ez a verzio külső service-től független hardcoded placeholder image data URL-El*/

import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { trigger, transition, animate, style } from '@angular/animations';

const imgDataUri = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gU3ZnIFZlY3RvciBJY29ucyA6IGh0dHA6Ly93d3cub25saW5ld2ViZm9udHMuY29tL2ljb24gLS0+DQo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwMCAxMDAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMDAwIDEwMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPG1ldGFkYXRhPiBTdmcgVmVjdG9yIEljb25zIDogaHR0cDovL3d3dy5vbmxpbmV3ZWJmb250cy5jb20vaWNvbiA8L21ldGFkYXRhPg0KPGc+PHBhdGggZD0iTTg4MS4xLDEzMi41SDExOC45QzU5LDEzMi41LDEwLDE4MS41LDEwLDI0MS40djUxNy4zYzAsNTkuOSw0OSwxMDguOSwxMDguOSwxMDguOWg3NjIuMmM1OS45LDAsMTA4LjktNDksMTA4LjktMTA4LjlWMjQxLjRDOTkwLDE4MS41LDk0MSwxMzIuNSw4ODEuMSwxMzIuNXogTTk0OS4yLDc0Ny4zYzAsNTQuOS0yNC41LDc5LjQtNzkuNCw3OS40SDEzMC4zYy01NC45LDAtNzkuNC0yNC41LTc5LjQtNzkuNFYyNTIuN2MwLTU0LjksMjQuNS03OS40LDc5LjQtNzkuNGg3MzkuNWM1NC45LDAsNzkuNCwyNC41LDc5LjQsNzkuNFY3NDcuM3ogTTMxNi4zLDQxOC4zTDQxOC4zLDUwMGwyNjUuNC0yMjQuNmwyMDQuMiwxODMuOHYzMDYuM0gxMTIuMVY1ODEuN0wzMTYuMyw0MTguM3ogTTE5My44LDIzNC42Yy00NS4xLDAtODEuNywzNi42LTgxLjcsODEuN3MzNi42LDgxLjcsODEuNyw4MS43czgxLjctMzYuNiw4MS43LTgxLjdTMjM4LjksMjM0LjYsMTkzLjgsMjM0LjZ6Ii8+PC9nPg0KPC9zdmc+';

@Component({
  selector: 'app-webi-image',
  templateUrl: './webi-image.component.html',
  styleUrls: ['./webi-image.component.css'],
  animations : [
    trigger('animEnter', [
      transition(':enter', [
          style({opacity: 0}),
          animate('2s', style({opacity: 1})),
      ])
    ]),
    trigger('animLeave', [
      transition(':leave', [
          style({opacity: 0.3}),
          animate('500ms', style({opacity: 0})),
      ])
    ])
  ]
})


export class WebiImageComponent implements OnInit {

  public placeholderImgDataUri: SafeResourceUrl;
  public imageLoaded: boolean;


  @Input('sources') sources: string [];
  @Input('svgstyle') svgstyle: string;
  @Input('imagestyle') imagestyle: string;

  @ViewChild('svgImg', {static: false}) svgImg: ElementRef;
  @ViewChild('realImg', {static: false}) realImg: ElementRef;

  constructor(

    private sanitizer: DomSanitizer
  ) {
   this.imageLoaded = false;
  }

  ngOnInit() {
    this.placeholderImgDataUri = this.sanitizer.bypassSecurityTrustResourceUrl(imgDataUri);
  }

  ngAfterViewInit() {
    this.svgImg.nativeElement.style = this.svgstyle;
  }

  public imgLoaded() {
    this.realImg.nativeElement.style = this.imagestyle;
    this.imageLoaded = true;
  }

  ngOnDestroy() {

  }
}
